/* eslint no-param-reassign: 0 */
import AccomodationCartItem from '@/classes/AccomodationCartItem';
import AddonCartItem from '@/classes/AddonCartItem';
import SkiPassAccomodationCartItem from '@/classes/SkiPassAccomodationCartItem';

export const pickAccomodation = ($, value) => {
  $.cart.accomodations = $.cart.accomodations.filter(a => a.confirmed);

  if (typeof value.no === 'number' && !isNaN(value.no) && value.no > -1 && $.cart.accomodations[value.no]) {
    $.cart.accomodations[value.no].period = value.period;
    $.cart.accomodations[value.no].week = value.week;
    $.cart.accomodations[value.no].price = value.price;
    if (value.pool_lid) {
      $.cart.accomodations[value.no].poolLid = value.pool_lid;
    }
    if (value.unit_lid) {
      $.cart.accomodations[value.no].unitLid = value.unit_lid;
    }
    if (value.capacity) {
      $.cart.accomodations[value.no].capacity = value.capacity;
    }
    if (value.unit) {
      $.cart.accomodations[value.no].name = (value.unit.display_name || value.unit.description_title) + (value.unit.subtitle ? (` - ${value.unit.subtitle}`) : '');

      if (value.unit.pool) {
        $.cart.accomodations[value.no].pool_name =
          value.unit.pool.display_name || value.unit.pool.name;
      }
    }

    $.cart.accomodations[value.no].site = value.site;

    $.cart.accomodations[value.no].unit_code = value.unit_code;
    $.cart.accomodations[value.no].description_title = value.description_title;
  } else {
    const item = new AccomodationCartItem();
    item.poolLid = value.pool_lid;
    item.unitLid = value.unit_lid;
    item.period = value.period;
    item.week = value.week;
    if (value.unit) {
      item.name = (value.unit.display_name || value.unit.description_title) + (value.unit.subtitle ? (` - ${value.unit.subtitle}`) : '');

      if (value.unit.pool) {
        item.pool_name = value.unit.pool.display_name || value.unit.pool.name;
      }
    }
    item.capacity = value.capacity;
    item.quantity = 1;
    item.price = value.price;

    item.site = value.site;

    item.unit_code = value.unit_code;
    item.description_title = value.description_title;

    $.cart.accomodations.push(item);
  }

  $.cart.currentAccomodationIndex = $.cart.accomodations.length - 1;
};

export const refreshCart = ($) => {
  const confirmedAccomodations = $.cart.accomodations
    .filter(obj => obj.confirmed)
    .reduce((current, obj) => (parseInt(obj.quantity, 10) + current), 0);

  const confirmedSkipasses = $.cart.skipasses
    .filter(obj => obj.confirmed && obj.type !== 'SKIPASS-ACCO')
    .reduce((current, obj) => (parseInt(obj.quantity, 10) + current), 0);

  const confirmedSkipasses2 = $.cart.skipasses
    .filter(obj => obj.confirmed && obj.type === 'SKIPASS-ACCO')
    .reduce((current, obj) => (parseInt(obj.adults, 10) +
      parseInt(obj.children, 10) + parseInt(obj.youths, 10) + current), 0);

  const confirmedAddons = $.cart.addons
    .filter(obj => obj.confirmed)
    .reduce((current, obj) => (parseInt(obj.quantity, 10) + current), 0);

  const confirmedRentals = $.cart.rentals
    .filter(obj => obj.confirmed)
    .reduce((current, obj) => (parseInt(obj.quantity, 10) + current), 0);

  const confirmedSkischools = $.cart.skischools
    .filter(obj => obj.confirmed)
    .reduce((current, obj) => (parseInt(obj.quantity, 10) + current), 0);

  let confirmedActivities = 0;
  if ($.cart.activities && $.cart.activities.length) {
    confirmedActivities = $.cart.activities
      .filter(obj => obj.confirmed)
      .reduce((current, obj) => (parseInt(obj.quantity, 10) + current), 0);
  }

  // Delivery Fee logic
  const rentalConfig = window.SITE_CONFIG && window.SITE_CONFIG.rental;
  if (rentalConfig && rentalConfig.delivery_fee_active) {
    const feePoolLid = rentalConfig.delivery_fee_pool_lid;
    const feePrice = rentalConfig.delivery_fee_price;
    const feeName = rentalConfig.delivery_fee_name;

    const hasDeliveryRental = $.cart.rentals.some(r => r.confirmed && r.delivery);

    // Check if parent order already has this product (addon booking / tilläggsbokning)
    let parentHasFee = false;
    if ($.cart.addToOrder && $.cart.addToOrder.lines) {
      parentHasFee = $.cart.addToOrder.lines.some(l =>
        l.status !== 'C' && parseInt(l.poolId, 10) === parseInt(feePoolLid, 10));
    }
    const confirmedAccomodation = $.cart.accomodations.find(a => a.confirmed);
    if (confirmedAccomodation && confirmedAccomodation.parent_has_delivery_fee) {
      parentHasFee = true;
    }
    if ($.cart.parent_has_delivery_fee) {
      parentHasFee = true;
    }

    if (!$.cart.products) {
      $.cart.products = [];
    }

    const feeProductIndex = $.cart.products.findIndex(p =>
      parseInt(p.poolId, 10) === parseInt(feePoolLid, 10));

    if (hasDeliveryRental && !parentHasFee) {
      if (feeProductIndex === -1) {
        $.cart.products.push({
          type: 'PRODUCT',
          poolId: feePoolLid,
          name: feeName,
          price: feePrice,
          quantity: 1,
          confirmed: true,
        });
      } else {
        $.cart.products[feeProductIndex].price = feePrice;
        $.cart.products[feeProductIndex].name = feeName;
        $.cart.products[feeProductIndex].quantity = 1;
        $.cart.products[feeProductIndex].confirmed = true;
      }
    } else if (feeProductIndex > -1) {
      $.cart.products.splice(feeProductIndex, 1);
    }
  }

  const sum = confirmedAccomodations + confirmedSkipasses + confirmedSkipasses2 +
    confirmedAddons + confirmedRentals + confirmedSkischools + confirmedActivities;

  $.cartSum = sum;

  if (sum) {
    if (document.querySelectorAll('.cart-counter')) {
      const divs = document.querySelectorAll('.cart-counter');
      for (let i = 0; i < divs.length; ++i) { // eslint-disable-line
        divs[i].innerHTML = sum;
      }
    }
  } else if (document.querySelectorAll('.cart-counter')) {
    const divs = document.querySelectorAll('.cart-counter');
    for (let i = 0; i < divs.length; ++i) { // eslint-disable-line
      divs[i].innerHTML = '';
    }
  }
};

export const addAccomodationSkipasses = ($, value) => {
  const skipass = new SkiPassAccomodationCartItem();

  skipass.adults = value.adults;
  skipass.youths = value.youths;
  skipass.children = value.children;
  skipass.seniors = value.seniors;
  skipass.days = value.days;

  skipass.belongsTo = value.belongsTo;

  $.cart.skipasses.push(skipass);

  refreshCart($);
};

export const confirmAccomodation = ($, value) => {
  const index = value.index;
  $.cart.accomodations[index].confirmed = true;
  $.cart.accomodations[index].adults = parseInt(value.adults, 10);
  $.cart.accomodations[index].youths = parseInt(value.youths, 10);
  $.cart.accomodations[index].children = parseInt(value.children, 10);
  $.cart.accomodations[index].seniors = parseInt(value.seniors, 10) || 0;

  let currentSkipassIndex = -1;
  $.cart.skipasses.forEach((skipass, localIndex) => {
    if (skipass.type === 'SKIPASS-ACCO' && skipass.belongsTo === value.index) {
      currentSkipassIndex = localIndex;
    }
  });

  if (currentSkipassIndex === -1) {
    addAccomodationSkipasses($, {
      adults: $.cart.accomodations[index].adults,
      youths: $.cart.accomodations[index].youths,
      children: $.cart.accomodations[index].children,
      seniors: $.cart.accomodations[index].seniors || 0,
      days: value.days,
      belongsTo: index,
    });
  }

  $.cart.currentSkipassIndex = $.cart.skipasses.length - 1;
  refreshCart($);
};

export const confirmSkipasses = ($, value) => {
  const index = value.index;
  $.cart.skipasses[index].confirmed = true;
  $.cart.skipasses[index].adultLid = value.adultLid;
  $.cart.skipasses[index].youthLid = value.youthLid;
  $.cart.skipasses[index].childLid = value.childLid;
  $.cart.skipasses[index].seniorLid = value.seniorLid;

  $.cart.deliveryTo = value.deliveryTo;

  $.cart.skipasses[index].hideadults = !parseInt($.cart.skipasses[index].adults, 10);
  $.cart.skipasses[index].hideyouths = !parseInt($.cart.skipasses[index].youths, 10);
  $.cart.skipasses[index].hidechildren = !parseInt($.cart.skipasses[index].children, 10);
  $.cart.skipasses[index].hideseniors = !parseInt($.cart.skipasses[index].seniors, 10);

  $.cart.skipasses[index].delivery_type = value.deliveryType;
  $.cart.skipasses[index].site = value.site;

  if (value.days) {
    $.cart.skipasses[index].days = parseInt(value.days, 10);
  }

  refreshCart($);
};

export const unconfirmSkipasses = ($) => {
  const index = $.cart.currentSkipassIndex;
  $.cart.skipasses[index].confirmed = false;
  refreshCart($);
};

export const addAddon = ($, payload) => {
  const addon = new AddonCartItem();
  addon.quantity = parseInt(payload.qtySelected, 10);
  addon.lid = payload.lid;
  addon.confirmed = true;
  addon.title = payload.arttext;
  addon.price = parseFloat(payload.aprice);
  addon.rut = payload.rut;
  addon.hide_for_guest = payload.hide_for_guest;

  addon.locked = payload.locked;

  if ($.cart.ssn && payload.rut) {
    addon.discount = {
      type: 'percentage',
      code: 'rut',
      amount: 50,
    };
  } else {
    addon.discount = null;
  }

  addon.editableQuantity = (payload.max_qty > 1);

  addon.belongsTo = payload.belongsTo;

  const index = $.cart.addons.findIndex(a =>
    a.lid === addon.lid && a.belongsTo === addon.belongsTo);

  if (index > -1) {
    $.cart.addons.splice(index, 1);
  }

  $.cart.addons.push(addon);

  $.cart.currentAddonIndex = $.cart.addons.length - 1;
  refreshCart($);
};

export const removeAddon = ($, payload) => {
  const index = $.cart.addons.findIndex(addon =>
    addon.lid === payload.lid && addon.belongsTo === payload.belongsTo);

  if (index > -1) {
    $.cart.addons.splice(index, 1);
  }

  /**
   * Filter out all remaining addons that has RUT
   */
  const rutAddons = $.cart.addons.filter(localAddon => localAddon.rut);

  /* *
    * If no addons with RUT is left, remove ssn from the state store
    * */
  if (!rutAddons.length) {
    $.cart.ssn = null;
  }
  refreshCart($);
};

export const addSkipasses = ($, payload) => {
  const skipass = new SkiPassAccomodationCartItem();
  skipass.adults = 0;
  skipass.youths = 0;
  skipass.children = 0;
  skipass.seniors = 0;
  skipass.confirmed = true;

  skipass[payload.age] = parseInt(payload.number, 10);
  skipass.days = parseInt(payload.days, 10);

  $.cart.skipasses.push(skipass);

  $.cart.currentSkipassIndex = $.cart.skipasses.length - 1;
};

export const accomodationPeriodPick = ($, value) => {
  $.tempCartAccomodation = value;
};

export const refreshFavorites = ($) => {
  if ($.favorites.length) {
    if (document.querySelectorAll('.favorite-conter')) {
      const divs = document.querySelectorAll('.favorite-counter');
      for (let i = 0; i < divs.length; ++i) { // eslint-disable-line
        divs[i].innerHTML = $.favorites.length;
      }
    }
  } else if (document.querySelectorAll('.favorite-conter')) {
    const divs = document.querySelectorAll('.favorite-counter');
    for (let i = 0; i < divs.length; ++i) { // eslint-disable-line
      divs[i].innerHTML = '';
    }
  }
};

export const addFavorite = ($, value) => {
  $.favorites.push(value);
  refreshFavorites($);
};

export const removeFavorite = ($, value) => {
  $.favorites.splice(value, 1);
  refreshFavorites($);
};

const makeid = () => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (var i = 0; i < 12; i++) { // eslint-disable-line
    text += possible.charAt(Math.floor(Math.random() * possible.length)); // eslint-disable-line
  }

  return text;
};

export const clearCart = ($) => {
  $.cart.accomodations = [];
  $.cart.addons = [];
  $.cart.skipasses = [];
  $.cart.rentals = [];
  $.cart.skischools = [];
  $.cart.products = [];
  $.cart.pincode = null;
  $.cart.campaignCode = null;
  $.cart.codeRequiresExtraInfo = null;
  $.cart.codeExtraInfo = '';
  $.cart.ssn = null;
  $.cart.addToOrder = {};
  $.cart.deliveryTo = {};
  $.cart.parent_has_delivery_fee = false;
  $.cart.receipt = null;

  $.cart.phone = null;
  $.cart.email = null;
  $.cart.name = null;
  $.cart.notes = null;

  $.cart.rentalDateRestriction = {};

  $.lockingActive = false;
  $.lockingBeforeTime = false;
  $.lockingCode = false;

  $.pincode = '';
  $.campaignCode = '';

  $.user_code = makeid();

  document.body.classList.remove('klarna-checkout-fso-open');
  refreshCart($);
};

export const setUserCode = ($, code) => {
  $.user_code = code;
};

export const setUser = ($, user) => {
  $.user.token = user.token;
};

export const dontAwaitFilter = ($) => {
  $.isAwaitingFilter = false;
};

export const awaitFilter = ($, payload) => {
  const defaultOptions = {
    waitForUser: false,
    callback: null,
  };

  const options = Object.assign({}, defaultOptions, payload);

  if (options.waitForUser) {
    $.isAwaitingUserSince = new Date();

    setTimeout(() => {
      const now = new Date();
      const diff = now - $.isAwaitingUserSince;

      if (diff < 1000) {
        return;
      }

      $.isAwaitingFilter = true;
      setTimeout(() => {
        dontAwaitFilter($);

        if (options.callback && typeof options.callback === 'function') {
          options.callback();
        }
      }, (250));
    }, (1001));
  } else {
    $.isAwaitingFilter = true;
    setTimeout(() => {
      dontAwaitFilter($);
    }, (250));
  }
};

export const saveCartLocking = ($, payload) => {
  if (payload.code && payload.code !== 'undefined') {
    $.lockingCode = payload.code;
    $.lockingActive = true;
  } else {
    $.lockingCode = null;
  }

  if (payload.beforeTime && payload.beforeTime !== 'undefined') {
    $.lockingBeforeTime = payload.beforeTime;
  } else {
    $.lockingBeforeTime = null;
  }
};

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/mutations/accomodation.js